<template>
  <div class="topic">

    <!-- 统计卡片 -->
    <div class="statistic"  :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }">
        <StatCard1
                v-for="stat in stats"
                :key="stat.id"
                :icon="stat.icon"
                :label="stat.label"
                :value="stat.value"
                :trendClass="stat.trendClass"
        />
    </div>

    <div class="wrapper">
      <div class="card">
        <div class="header">
          <div class="title">任务历史分析</div>
          <div class="extra">
            <a-button-group size="small">
              <a-button :type="type === '本月' ? 'primary' : 'default'" @click="type = '本月'">本月</a-button>
              <a-button :type="type === '全年' ? 'primary' : 'default'" @click="type = '全年'">全年</a-button>
            </a-button-group>
          </div>
        </div>

        <FacilityErrorAnalysis :detail="detail" />
      </div>

      <div class="card">
        <div class="header">
          <div class="title">任务来源</div>
          <div class="extra">
            <a-button-group size="small">
              <a-button :type="type === '本月' ? 'primary' : 'default'" @click="type = '本月'">本月</a-button>
              <a-button :type="type === '全年' ? 'primary' : 'default'" @click="type = '全年'">全年</a-button>
            </a-button-group>
          </div>
        </div>
        <FacilityError :detail="detail" />
      </div>

      <div class="card">
        <div class="header">
          <div class="title">任务类型</div>
          <div class="extra">
            <a-button-group size="small">
              <a-button :type="type === '本月' ? 'primary' : 'default'" @click="type = '本月'">本月</a-button>
              <a-button :type="type === '全年' ? 'primary' : 'default'" @click="type = '全年'">全年</a-button>
            </a-button-group>
          </div>
        </div>
        <TaskRunning :detail="detail" />
      </div>
    </div>
    <div class="wrapper">
      <div class="card">
        <div class="header">
          <div class="title">平均时长分析</div>
          <div class="extra">
            <a-button-group size="small">
              <a-button :type="type === '本月' ? 'primary' : 'default'" @click="type = '本月'">本月</a-button>
              <a-button :type="type === '全年' ? 'primary' : 'default'" @click="type = '全年'">全年</a-button>
            </a-button-group>
          </div>
        </div>
        <TaskAnalysis :detail="detail" />
      </div>

      <div class="card">
        <div class="header">
          <div class="title">人员考核</div>
          <div class="extra">
            <a-button-group size="small">
              <a-button :type="type === '本月' ? 'primary' : 'default'" @click="type = '本月'">本月</a-button>
              <a-button :type="type === '全年' ? 'primary' : 'default'" @click="type = '全年'">全年</a-button>
            </a-button-group>
          </div>
        </div>

        <div style="padding: 2vh">
            <Tablelist
                    :showCheckbox="false"
                    :list="Array.isArray(detail.dashboardWorkers) ? detail.dashboardWorkers : []"
                    :columns="tableColumns"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatCard1 from "@/components/water-affairs-style/StatCard1.vue"
import TaskRunning from "./components/task-running.vue";
import TaskAnalysis from "./components/task-analysis.vue";
import FacilityError from "./components/facility-error.vue";
import FacilityErrorAnalysis from "./components/facility-error-analysis.vue";

import request from '@/api/request'

export default {
  components: {
    TaskRunning,
    TaskAnalysis,
    FacilityError,
    FacilityErrorAnalysis,
    StatCard1
  },
  data() {
    return {
        columns: 4,
        statistic: {
            total: 87.5,
            assigned: 156,
            finished: 98.2,
            unfinished: 23,
        },
      // type: "本月",
      type: '全年',
      stats: [
          { id: 1, icon: '/icons/task/icon4.png', trend: '', trendClass: 'trend-up', value: '', label: '全部工单' },
          { id: 2, icon: '/icons/task/icon3.png', trend: '', trendClass: 'trend-up', value: '', label: '派发工单' },
          { id: 3, icon: '/icons/task/icon2.png', trend: '', trendClass: 'trend-up', value: '', label: '已完成工单' },
          { id: 4, icon: '/icons/task/icon1.png', trend: '', trendClass: 'trend-up', value: '', label: '未完成工单' },
      ],
      detail: {},
      tableColumns:[
          {
              key: 'id',
              title: '序号',
              field: 'id',
              infotype: 'index'
          },
          {
              key: 'name',
              title: '姓名',
              field: 'name',
              infotype: 'text'
          },  {
              key: 'total',
              title: '任务个数',
              field: 'total',
              infotype: 'text'
          },  {
              key: 'finished',
              title: '完成个数',
              field: 'finished',
              infotype: 'text'
          },  {
              key: 'overdue',
              title: '预期个数',
              field: 'overdue',
              infotype: 'text'
          },  {
              key: 'workingHours',
              title: '总工时(h)',
              field: 'workingHours',
              infotype: 'text'
          },
      ]
    };
  },

  mounted() {
    this.getData();

    this.getList();
  },

  watch: {
      statistic: {
          deep: true,
          handler() {
              this.updateStats();
          },
      },
    type() {
      this.getList();
    }
  },

  methods: {
      updateStats() {
          this.stats[0].value = this.statistic.total;
          this.stats[1].value = this.statistic.assigned;
          this.stats[2].value = this.statistic.finished;
          this.stats[3].value = this.statistic.unfinished;
      },
    getData() {
      request({
        url: '/model-analysis/inspectTask/queryDashboardTotal',
      }).then(res => {

        this.statistic = res || {}
      })
    },

    getList() {

      let condition = 'year'
      if (this.type === '本月') {
        condition = 'month'
      }

      const hide = this.$message.loading('加载中...')
      request({
        url: '/model-analysis/inspectTask/queryDashboardAnalysis/' + condition
      }).then(res => {
        this.detail = res ? Object.freeze(res) : {}
      }).finally(() => {
        hide();
      })

    }
  }

};
</script>

<style lang="less" scoped>
.topic {
  width: 90%;
  margin: auto;
  padding: 2vh 1vw;
}
.statistic{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.wrapper {
  display: flex;
  gap: 2vh;
  margin-bottom: 2vh;

  .card {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    flex: 1;

    .header {
      //background-color: var(--theme-color);
      color: #fff;
      display: flex;
      align-items: center;
      padding: 1vh 1vw;

      .title {
        font-weight: bold;
      }

      .extra {
        margin-left: auto;
      }
    }
  }
}

::v-deep .ant-btn{
  color: #e1e1e1;
  background-color: rgba(0, 255, 150, 0.1);
  border-color: #105055;
}

::v-deep .ant-btn-primary {
  background:linear-gradient(135deg, #00ff96, #00d4ff);
  color: #0e1b34;
}
</style>